(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('model', {
            parent: 'entity',
            url: '/model',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.model.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model/models.html',
                    controller: 'ModelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('model');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('model-detail', {
            parent: 'entity',
            url: '/model/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.model.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model/model-detail.html',
                    controller: 'ModelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('model');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Model', function($stateParams, Model) {
                    return Model.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('model.new', {
            parent: 'model',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model/model-dialog.html',
                    controller: 'ModelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                isLinear: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('model', null, { reload: true });
                }, function() {
                    $state.go('model');
                });
            }]
        })
        .state('model.edit', {
            parent: 'model',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model/model-dialog.html',
                    controller: 'ModelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Model', function(Model) {
                            return Model.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('model.delete', {
            parent: 'model',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model/model-delete-dialog.html',
                    controller: 'ModelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Model', function(Model) {
                            return Model.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
